import * as React from 'react';
import { CheckBoxButtonContainer } from './container';
import { CheckBoxButtonContent } from './content';

export const CheckBoxButton = () => (
  <CheckBoxButtonContainer>
    <CheckBoxButtonContent />
  </CheckBoxButtonContainer>
);
